import React, { useState, useEffect } from 'react';
import { Form, Col } from 'react-bootstrap';

import styles from './SearchRedemptionDrodown.module.scss';
import { connect } from 'react-redux';

/**
 * @component SearchRedemptionDrodown
 * @description Dropdown component for selecting search type when filtering redemptions.
 * Allows users to choose between searching by Redemption ID, Reference Code, or Merchant Name.
 * The Merchant Name option is restricted to admin users only.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onSelectChange - Callback function triggered when dropdown selection changes
 * @param {Object} props.auth - Authentication object from Redux store containing user details
 * @param {string} props.value - Currently selected dropdown value
 *
 * @returns {JSX.Element} Dropdown select component
 */
const SearchRedemptionDrodown = (props) => {
  const { onSelectChange, auth, value, isMerchantWithCustomLabels } = props;

  const [isAdmin, setIsAdmin] = useState(false);

  /**
   * Effect hook to determine admin status based on user role
   * Sets isAdmin state to true for specific admin roles:
   * - ROLE_THYAGA_ACCOUNTANT
   * - ROLE_THYAGA_ADMINISTRATOR
   * - ROLE_THYAGA_CUSTOMER_CARE
   *
   * @dependency {string} auth.details.role - User role from authentication state
   */
  useEffect(() => {
    if (
      auth.details.role === 'ROLE_THYAGA_ACCOUNTANT' ||
      auth.details.role === 'ROLE_THYAGA_ADMINISTRATOR' ||
      auth.details.role === 'ROLE_THYAGA_CUSTOMER_CARE'
    ) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [auth.details.role]);

  return (
    <div className={styles.root__div}>
      <div>
        <Form.Row>
          <Col>
            <Form.Control
              className={styles.tsubmerchant_picker__control}
              as='select'
              onChange={(e) => onSelectChange(e.target.value)}
              value={value}
            >
              <option value='REDEMPTION_ID'>
                {isMerchantWithCustomLabels ? 'Payment Reference Id' : 'Redemption ID'}
              </option>
              <option value='REFERENCE_CODE'>
                {isMerchantWithCustomLabels ? 'Order Id' : 'Reference Code'}
              </option>
              <option hidden={!isAdmin} value='MERCHANT_NAME'>
                Merchant Name
              </option>
            </Form.Control>
          </Col>
        </Form.Row>
      </div>
    </div>
  );
};

/**
 * Maps Redux state to component props
 * @param {Object} state - Redux store state
 * @returns {Object} Props object containing authentication data
 */
const mapStateToProps = (state) => ({
  auth: state.auth.auth,
});

export default connect(mapStateToProps)(SearchRedemptionDrodown);
